import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../../../common/state/store";
import type { IAppLoaderAction } from "src/common/state/loaderHandleMiddleware";
import apiUrls from "src/api";
import axios from "axios";

export interface ILanguage {
  id: number;
  name: string;
  ISO_639_1: string;
  IETF_BCP_47: string;
  right_to_left: boolean;
}

interface ILanguagesState {
  all: ILanguage[];
}
const initialState: ILanguagesState = {
  all: [],
};

export interface ITranslateProjectPayload {
  projectId: number;
  targetLanguageIds: number[];
  contentId?: number;
  cb?: () => void;
  errorCb?: (error: unknown) => void;
}

export interface ITranslateProjectResponse {
  success: boolean;
  targetLanguageIds: number[];
  translations: { succeeded: number; failed: number };
  mediaCopy: { succeeded: number; total: number };
}

export const fetchLanguages = createAsyncThunk(
  "languages/fetchLanguages",
  // eslint-disable-next-line no-empty-pattern
  async ({}: IAppLoaderAction) => {
    return await axios
      .get<ILanguage[]>(apiUrls.languages)
      .then((res) => {
        return res.data;
      })
      .catch((error: unknown) => {
        console.error(error);
        throw error;
      });
  },
);

export const translateProject = createAsyncThunk(
  "languages/translateproject",
  async ({
    projectId,
    targetLanguageIds,
    contentId,
    cb,
    errorCb,
  }: ITranslateProjectPayload & IAppLoaderAction) => {
    return await axios
      .post<ITranslateProjectResponse>(`${apiUrls.projects.translateProject}`, {
        projectId,
        targetLanguageIds,
        ...(contentId !== undefined ? { contentId } : {}),
      })
      .then((res) => {
        if (cb) {
          cb();
        }
        if (res !== undefined) {
          return res.data;
        }
        return undefined;
      })
      .catch((error: unknown) => {
        console.error(error);
        if (errorCb) {
          errorCb(error);
        }
      });
  },
);

export const languagesSlice = createSlice({
  name: "languages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLanguages.fulfilled, (state: ILanguagesState, { payload }) => {
      state.all = payload;
    });
  },
});

export const getAllLanguages = (state: RootState) => state.languages.all;

export default languagesSlice.reducer;
